import HttpService from "./http";

export type DemoRequestStatus = "open" | "granted" | "refused";
export type DemoDecision = Exclude<DemoRequestStatus, "open">;

export interface DemoRequest {
  id: string;
  partner_id: string;
  entity_id: string;
  entity_name: string | null;
  days: number;
  message: string | null;
  status: DemoRequestStatus;
  created_at: string;
  decided_at: string | null;
  decided_by: string | null;
  decision_reason: string | null;
}

const base = (customerId: string, entityId: string) =>
  `/${customerId}/${entityId}/partners/demo-requests`;

const PartnerDemoRequestService = {
  listOpen: async (customerId: string, entityId: string) =>
    (await HttpService.get(base(customerId, entityId))).data
      .element as DemoRequest[],

  decide: async (
    customerId: string,
    entityId: string,
    requestId: string,
    body: { decision: DemoDecision; reason: string }
  ) =>
    (
      await HttpService.post(
        `${base(customerId, entityId)}/${encodeURIComponent(
          requestId
        )}/decision`,
        body
      )
    ).data.element as DemoRequest,
};

export default PartnerDemoRequestService;
